import { useEffect, useState } from "react";
import { FiEye } from "../../../../assets/icons/vander";
import { useShiftProcedureStore } from "../../../../hooks";
import { LoadingData, ErrorMessage, SuccessMessage } from "../../../ui";
import { translationAnesthesiaTechniques } from "../../../data";
import { ViewShiftProcedureModal } from "../modals";

export const ShiftProcedureTable = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    shiftProcedures,
    message,
    params,
    pageSize,
    page,

    // Methods
    startGetShiftProcedures,
  } = useShiftProcedureStore();

  // States ------------------------------------------------//
  const [shiftProcedure, setShiftProcedure] = useState(null);
  const [isViewShiftProcedureModal, setIsViewShiftProcedureModal] =
    useState(null);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const openViewShiftProcedureModal = (shiftProcedure) => {
    setIsViewShiftProcedureModal(true);
    setShiftProcedure(shiftProcedure);
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (shiftProcedures.data.length === 0) {
      startGetShiftProcedures(params, page, pageSize);
    }
  }, [shiftProcedures.data, startGetShiftProcedures, params, page, pageSize]);

  return (
    <>
      {shiftProcedures.isLoading && <LoadingData className="mb-4" />}
      {shiftProcedures.message?.type === "error" && (
        <ErrorMessage className="mb-4">
          {shiftProcedures.message.text}
        </ErrorMessage>
      )}
      {message?.type === "success" && (
        <SuccessMessage className={"mb-4"}>{message.text}</SuccessMessage>
      )}

      <div
        className="table-responsive shadow rounded"
        style={{ fontFamily: "Inter, sans-serif" }}
      >
        <table className="table table-center bg-white mb-0">
          <thead>
            <tr>
              <th className="border-bottom p-3" style={{ minWidth: "50px" }}>
                #
              </th>
              <th className="border-bottom p-3">Doctor</th>
              <th className="border-bottom p-3">Paciente</th>
              <th className="border-bottom p-3">Fecha y hora</th>
              <th className="border-bottom p-3">Tecnica anestesica</th>
              <th className="border-bottom p-3">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {shiftProcedures.data.map((shiftProcedure, index) => (
              <tr key={shiftProcedure.id}>
                <th className="p-3">{index + 1}</th>
                <td className="py-3">{`${shiftProcedure.doctor.user.firstName} ${shiftProcedure.doctor.user.lastName}`}</td>
                <td className="py-3">{`${shiftProcedure.patientName}`}</td>
                <td className="py-3">{shiftProcedure.procedureTime}</td>
                <td className="py-3">
                  {
                    translationAnesthesiaTechniques[
                      shiftProcedure.anesthesiaTech
                    ]
                  }
                </td>
                <td className="text-center py-3">
                  <button
                    to="#"
                    className="btn btn-icon btn-pills btn-soft-primary"
                    onClick={() => openViewShiftProcedureModal(shiftProcedure)}
                  >
                    <FiEye />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ViewShiftProcedureModal
        isOpen={isViewShiftProcedureModal}
        setIsOpen={setIsViewShiftProcedureModal}
        shiftProcedure={shiftProcedure}
      />
    </>
  );
};
